module.exports = __webpack_public_path__ + "img/popup-topzj.cd624f49.png";